/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DiscountTypeEnum } from './DiscountTypeEnum';
import {
    DiscountTypeEnumFromJSON,
    DiscountTypeEnumFromJSONTyped,
    DiscountTypeEnumToJSON,
    DiscountTypeEnumToJSONTyped,
} from './DiscountTypeEnum';

/**
 * 
 * @export
 * @interface DiscountNew
 */
export interface DiscountNew {
    /**
     * 
     * @type {string}
     * @memberof DiscountNew
     */
    title: string;
    /**
     * 
     * @type {Date}
     * @memberof DiscountNew
     */
    validFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof DiscountNew
     */
    validTo: Date;
    /**
     * 
     * @type {number}
     * @memberof DiscountNew
     */
    discount: number;
    /**
     * 
     * @type {DiscountTypeEnum}
     * @memberof DiscountNew
     */
    discountType: DiscountTypeEnum;
}



/**
 * Check if a given object implements the DiscountNew interface.
 */
export function instanceOfDiscountNew(value: object): value is DiscountNew {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('validFrom' in value) || value['validFrom'] === undefined) return false;
    if (!('validTo' in value) || value['validTo'] === undefined) return false;
    if (!('discount' in value) || value['discount'] === undefined) return false;
    if (!('discountType' in value) || value['discountType'] === undefined) return false;
    return true;
}

export function DiscountNewFromJSON(json: any): DiscountNew {
    return DiscountNewFromJSONTyped(json, false);
}

export function DiscountNewFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscountNew {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'validFrom': (new Date(json['validFrom'])),
        'validTo': (new Date(json['validTo'])),
        'discount': json['discount'],
        'discountType': DiscountTypeEnumFromJSON(json['discountType']),
    };
}

export function DiscountNewToJSON(json: any): DiscountNew {
    return DiscountNewToJSONTyped(json, false);
}

export function DiscountNewToJSONTyped(value?: DiscountNew | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'validFrom': ((value['validFrom']).toISOString()),
        'validTo': ((value['validTo']).toISOString()),
        'discount': value['discount'],
        'discountType': DiscountTypeEnumToJSON(value['discountType']),
    };
}

